import React, { useEffect, useState } from 'react'
import Alert from '@mui/material/Alert'
import Snackbar from '@mui/material/Snackbar'
import { useDispatch, useSelector } from 'react-redux'
import { setAlert } from '../source/slice/AlertSlice'

const CustomSnackbar = () => {
    const alert = useSelector((state: any) => state.alert.value)
    const [open, setOpen] = useState(false)
    const [displayed, setDisplayed] = useState(alert)
    const dispatch = useDispatch()

    useEffect(() => {
        if (alert !== undefined && alert !== null && alert.length !== 0 && !!alert?.message) {
            setDisplayed(alert)
            setOpen(true)
        }
    }, [alert])

    const handleClose = () => {
        setOpen(false)
        setTimeout(() => {
            dispatch(setAlert(null))
            setDisplayed(null)
        }, 300)
    }

    return (
        <Snackbar open={open} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} sx={{ marginBottom: 6 }}>
            <Alert onClose={handleClose} variant="filled" severity={displayed?.type} sx={{ width: '100%' }}>
                {displayed?.message}
            </Alert>
        </Snackbar>
    )
}

export default CustomSnackbar
